import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Footer from '../Components/Footer';
import Header from '../Components/Header';

/// These styles ensure the footer stays at the bottom of the page
const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
`;

const Layout = () => (
  <PageWrapper>
    <Header />
    <Main>
      <Outlet />
    </Main>
    <Footer />
  </PageWrapper>
);

export default Layout;
